import styled, { css } from "styled-components";
import { InputWrapper } from "../inputWrapper";
import { inputHighlighting } from "../../../utils/helpers/inputHighlighting";
import { Radio } from "../../icons";
import { ValidationMessage } from "../validationMessage";

export const CheckboxInputWrapper = styled(InputWrapper)(({ theme }) => css`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 20px;
  border-radius: 14px;

  ${inputHighlighting}
  
  ${Radio} {
    align-self: flex-start;
    width: 26px;
    margin-right: 10px;

    @media only screen and (min-width: ${theme.breakpoints.XM}) {
      margin-right: 20px;
    }
  }
  
  ${ValidationMessage} {
    padding-left: 36px;
    flex: 1 0 100%;
  }

  label {
    flex: 1;
  }
`);